<template>
  <div>
    <Datepicker />
    <ul>
      <li v-for="(item, i) in files" :key="i">
        <audio controls>
          <source :src="item.url" :type="item.type" />
        </audio>
        <a>{{ item.title }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { fetchFileList } from "@/api/index";
import moment from "moment";
// import sha256 from "js-sha256";
// import DetailInstruct from "./DetailInstruct";
import { mapState } from "vuex";
import { eventBus } from "@/main";
import Datepicker from "vuejs-datepicker";
import { ko } from "vuejs-datepicker/dist/locale";
export default {
  components: { Datepicker },
  data() {
    return {
      isEdit: false,
      ko: ko,
      moment: moment,
      display: true,
      confirmTitle: "",
      message1: "",
      message2: "",
      currentComponent: null,
      displayConfirm: false,
      files: [],
      dateKeyword: "",
      searchWord: "",
      currentPage: 1,
      totalPages: 0,
      typeCode: "",
      startYmd: "",
      endYmd: "",
      periodCode: ""
    };
  },
  mounted() {
    // this.email = this.userInfo.email;
    eventBus.$on("closeConfirm", () => {
      this.closeConfirm();
    });
    this.getFileList();
  },
  computed: {
    ...mapState(["userInfo"])
  },
  methods: {
    viewComponent(view) {
      this.currentComponent = view;
      // this.displayConfirm = true;
    },
    closeConfirm() {
      this.displayConfirm = false;
    },
    closeModal() {
      eventBus.$emit("closeModal", true);
    },
    customFormatter(date) {
      return moment(date).format("YYYY년 MM월 DD일");
    },
    handleClose() {
      setTimeout(() => {
        eventBus.$emit("closeModal", true);
      }, 2000);
    },

    confirm() {
      this.closeModal();
    },
    handleEditMode() {
      this.isEdit = !this.isEdit;
    },

    handleClick(components) {
      event.preventDefault();
      let routeData = this.$router.resolve({ name: components });
      window.open(routeData.href, "_blank");
    },
    handlePaging(page) {
      window.console.log("page", page);
      if (page > this.totalPages) return false;
      else if (page < 1) return false;
      this.currentPage = page;
      this.getUserList();
    },
    handleMenu(userId) {
      window.console.log("userId", userId);
      this.$router.push({ name: "userDetail", query: { id: userId } });
    },
    deleteMenu(id) {
      deleteUser(id).then(res => {
        window.console.log("deleteUser", res);
        if (res.status == 200) {
          window.console.log(res);
        } else {
          return alert(res.data.message);
        }
      });
    },
    reload() {
      this.currentPage = 1;
      this.searchWord = "";
      this.getFileList();
    },
    getFileList() {
      let params = {
        page: this.currentPage,
        searchWord: this.searchWord
        // typeCode: this.typeCode
        // startYmd: this.startYmd ? moment(this.startYmd).format("YYYYMMDD") : "",
        // endYmd: this.endYmd ? moment(this.endYmd).format("YYYYMMDD") : "",
        // periodCode: this.periodCode
      };
      fetchFileList(params).then(res => {
        window.console.log("fetchFileList", res);
        if (res.status == 200) {
          this.files = res.data.data;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
        } else {
          return alert(res.data.message);
        }
      });
    }
  }
};
</script>
